/**
 * Создает объект с функциями обратного вызова для обработки результатов отправки формы.
 * @returns {object} - Объект с функциями обратного вызова.
 */
function courseOrderRequest() {
    /**
     * Функция вызывается перед отправкой запроса и добавляет класс 'loader' к элементу body для отображения индикатора загрузки.
     */
    const beforeSend = () => document.body.classList.add('loader');

    const success = (response, form) => {
        // console.log(response);
        // console.log(form);
        form.reset();
        form.querySelector('input[name="deal_id"]').remove();
        form.removeAttribute('data-auto-submited');
        cloudPaymentsPay(
            window.location.href,
            response['description'],
            response['order_cost'],
            response['user_email'],
            response['order_id'],
            response['data'],
            response['public_id'],
            response['customer_receipt']
        );
        fadeOut(form.closest('.modal'), 0);
    }

    /**
     * Функция вызывается при возникновении ошибки во время запроса и обрабатывает ошибку.
     * @param {XMLHttpRequest} xhr - Объект XMLHttpRequest, содержащий информацию о запросе.
     * @param {string} exception - Строка, содержащая описание типа ошибки.
     */
    const onError = (xhr, exception) => this.ajaxErrors(xhr, exception);

    /**
     * Функция вызывается после завершения выполнения запроса и удаляет класс 'loader' у элемента body для скрытия индикатора загрузки.
     */
    const onComplete = () => document.body.classList.remove('loader');

    // Возвращаем объект с функциями обратного вызова
    return {beforeSend, success, onError, onComplete};
}

/**
 * Создает объект с функциями обратного вызова для обработки результатов отправки формы.
 * @returns {object} - Объект с функциями обратного вызова.
 */
function coursePrerecordingRequest() {
    /**
     * Функция вызывается перед отправкой запроса и добавляет класс 'loader' к элементу body для отображения индикатора загрузки.
     */
    const beforeSend = () => document.body.classList.add('loader');

    const success = (response, form) => {
        // console.log(response);
        // console.log(form);
        const isGetCourseError = response['get_course_prerecording']['result']['error'];
        const crmCode = response['code'];
        const message = response['message_for_user'];
        const modalThx = document.getElementById('modal_prerecording_thx');

        if (isGetCourseError && crmCode !== 200) {
            modalThx.querySelector('.modal__description').remove();
            modalThx.querySelector('.modal__content').insertAdjacentHTML('beforeend', message);
        }

        form.reset();
        form.querySelector('input[name="deal_id"]').remove();
        form.removeAttribute('data-auto-submited');

        fadeOut(form.closest('.modal'), 0);
        fadeIn(modalThx, 215);
    }

    /**
     * Функция вызывается при возникновении ошибки во время запроса и обрабатывает ошибку.
     * @param {XMLHttpRequest} xhr - Объект XMLHttpRequest, содержащий информацию о запросе.
     * @param {string} exception - Строка, содержащая описание типа ошибки.
     */
    const onError = (xhr, exception) => this.ajaxErrors(xhr, exception);

    /**
     * Функция вызывается после завершения выполнения запроса и удаляет класс 'loader' у элемента body для скрытия индикатора загрузки.
     */
    const onComplete = () => document.body.classList.remove('loader');

    // Возвращаем объект с функциями обратного вызова
    return {beforeSend, success, onError, onComplete};
}

/**
 * Создает объект с функциями обратного вызова для обработки результатов отправки формы.
 * @returns {object} - Объект с функциями обратного вызова.
 */
function courseFeedbackRequest() {
    /**
     * Функция вызывается перед отправкой запроса и добавляет класс 'loader' к элементу body для отображения индикатора загрузки.
     */
    const beforeSend = () => document.body.classList.add('loader');

    const success = (response, form) => {
        // console.log(response);
        // console.log(form);
        if (response.code === 200) {
            const modal = form.closest('.modal');
            const thxModal = document.getElementById('modal_lead_thx');

            form.reset();
            form.querySelector('input[name="deal_id"]').remove();
            form.removeAttribute('data-auto-submited');

            fadeOut(modal, 0);
            fadeIn(thxModal, 215);
        }
    }

    /**
     * Функция вызывается при возникновении ошибки во время запроса и обрабатывает ошибку.
     * @param {XMLHttpRequest} xhr - Объект XMLHttpRequest, содержащий информацию о запросе.
     * @param {string} exception - Строка, содержащая описание типа ошибки.
     */
    const onError = (xhr, exception) => this.ajaxErrors(xhr, exception);

    /**
     * Функция вызывается после завершения выполнения запроса и удаляет класс 'loader' у элемента body для скрытия индикатора загрузки.
     */
    const onComplete = () => document.body.classList.remove('loader');

    // Возвращаем объект с функциями обратного вызова
    return {beforeSend, success, onError, onComplete};
}

document.addEventListener('DOMContentLoaded', function () {

    /**
     * Находит все элементы курсовых пакетов.
     * @type {NodeListOf<Element>} NodeList элементов курсовых пакетов.
     */
    const coursePackages = document.querySelectorAll('.course-packages__list-item');
// Проверяем, есть ли пакеты курсов на странице
    if (coursePackages.length > 0) {

        // Перебираем каждый элемент пакета курсов
        coursePackages.forEach((packageItem, index) => {
            // Находим контейнер кнопок для каждого пакета
            const btnWrapper = packageItem.querySelector('.list-item__btn-wrap');
            // Кнопка покупки
            const buyBtn = btnWrapper.querySelector('.list-item__btn');

            // Кнопка предварительной записи
            const preRecBtn = btnWrapper.querySelector('.list-item__btn_prerecording');

            // Кнопка обратной связи с менеджером
            const feedbackBtn = btnWrapper.querySelector('.list-item__btn_manager');

            // Если кнопка покупки существует, добавляем обработчик событий
            if (buyBtn) {
                const modal = document.getElementById('modal_order_course');

                // Обработчик открытия модального окна и инициализации формы при клике на кнопку покупки
                buyBtn.addEventListener('click', event => fadeInModalAndInitForm({
                    event,
                    modal,
                    index,
                    isBuyBtn: true,
                    packageItem
                }));
            }

            // Если кнопка обратной связи с менеджером существует, добавляем обработчик событий
            if (feedbackBtn) {
                const modal = document.getElementById('modal_lead_course');

                // Обработчик открытия модального окна при клике на кнопку обратной связи
                feedbackBtn.addEventListener('click', event => fadeInModalAndInitForm({
                    event,
                    modal,
                    index
                }));
            }

            // Если кнопка предварительной записи существует, добавляем обработчик событий
            if (preRecBtn) {
                const modal = document.getElementById('modal_prerecording');

                // Обработчик открытия модального окна при клике на кнопку предварительной записи
                preRecBtn.addEventListener('click', event => fadeInModalAndInitForm({
                    event,
                    modal,
                    index
                }));
            }
        });
    }

    /**
     * Открывает модальное окно с анимацией и инициализирует форму в нем.
     *
     * @param {Object} params - Параметры функции.
     * @param {Event} params.event - Событие клика.
     * @param {HTMLElement} params.modal - Модальное окно для отображения.
     * @param {number} params.index - Индекс текущего элемента пакета.
     * @param {boolean} [params.isBuyBtn=false] - Флаг, указывающий, является ли кнопка "Покупка".
     * @param {HTMLElement|null} [params.packageItem=null] - Элемент текущего пакета, если доступен.
     */
    const fadeInModalAndInitForm = ({
                                        event,
                                        modal,
                                        index,
                                        isBuyBtn = false,
                                        packageItem = null
                                    }) => {
        // Отменяем стандартное поведение события
        event.preventDefault();
        const cookies = getCookies();
        const ageLimit = cookies.age_limit;
        const args = {
            modal,
            formReset: true,
            key: index
        };

        // Если кнопка является кнопкой покупки и элемент пакета передан
        if (isBuyBtn && packageItem !== null) {
            modal.querySelector('.promocode__btn_delete').style.display = 'none';
            modal.querySelector('.promocode__btn_apply').style.display = 'block';
            modal.querySelector('.input-promocode').removeAttribute('readonly');
            // Находим и используем данные из элемента пакета
            const btnWrapper = packageItem.querySelector('.list-item__btn-wrap');

            // Получаем цену из элемента пакета
            const priceInnerHtml = packageItem.querySelector('.list-item__price').innerHTML;

            // Заголовок курса из атрибутов данных
            const courseTitle = btnWrapper.dataset.title;

            // Заголовок пакета из текста элемента
            const packageTitle = packageItem.querySelector('.list-item__title').textContent;

            // Проверка, есть ли у пакета промокод
            const isPromo = JSON.parse(btnWrapper.dataset.promo);

            // Обновляем элементы модального окна
            const modalPriceWrapper = modal.querySelector('.modal__price');
            const modalDescription = modal.querySelector('.modal__description');
            const modalPromoCode = modal.querySelector('.form__row-wrap_promocode');

            // Обновляем описание модального окна с названием курса и тарифом
            modalDescription.innerHTML = `${courseTitle}.<br> Тариф ${packageTitle}`;

            // Обновляем цену в модальном окне
            modalPriceWrapper.innerHTML = priceInnerHtml;

            // Показываем или скрываем поле для промокода в зависимости от наличия промокода
            modalPromoCode.style.display = isPromo ? 'block' : 'none';
        }

        ageLimit ? ageLimitHandler(args) : initBuyModal(args);
    };
});
